import React from "react";
import "./Logo.css";
import Div from "@jumbo/shared/Div";
import Link from "@mui/material/Link";
import { ASSET_IMAGES } from "../../utils/constants/paths";
import PropTypes from "prop-types";

const Logo = ({ mini, mode, sx }) => {

  const getImageSrc = (isMini, themeMode) => {
    if (themeMode === "light") {
      return isMini
        ? `${ASSET_IMAGES}/HelixMiniLogo.png`
        // : `${ASSET_IMAGES}/Felix.png`
        : `${ASSET_IMAGES}/HRMFarmlogo.png`
    }
  };

  console.log("mode",mini)

  return (
    <Div sx={{ display: "inline-flex", ...sx }}>
      <span>
        <Link href="/home">
          <img
            className={mini ? "short-logo" : "full-logo"}
            src={getImageSrc(mini, mode)}
            width={mini ? 35 : 135}
            height={mini ? 30 : 40}
            alt="Foyer logo"
          />
        </Link>
      </span>
    </Div>
  );
};

Logo.propTypes = {
  mini: PropTypes.bool,
  mode: PropTypes.string,
  sx: PropTypes.object
};

Logo.defaultProps = {
  mini: false,
  mode: "light",
  sx: {},
};

export default Logo;
